// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2xqQk","box":"WorkspacesBox_box__3eWDR","node":"WorkspacesBox_node__38WwZ"};